import { Space } from '@mantine/core';
import { useState } from 'react';
import styled from '@emotion/styled';

import Form from './form';
import { axios } from '../../../../utils/axios';
import SpocTable from './table';
import moment from 'moment';

const Container = styled.div`
  margin-top: 22px;
`;

const AdminSpocs = () => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({});
  const [spocs, setSpocs] = useState({});
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState([]);

  const fetchSpoc = async () => {
    try {
      setLoading(true);
      const { data } = await axios.post('/costing-request/spoc-details', {
        ...form,
        roles: [form.role],
      });
      fetchUsers();
      const spocs = data.data.spoc_data;
      const backup = data.data.backup_spoc;
      setSpocs({
        ...form,
        primary_spoc: spocs?.[0]?.primary_id || undefined,
        secondary_spoc: spocs?.[0]?.secondary_id || undefined,
        backup_spoc: backup?.[0]?.backup_id || undefined,
        timestamp: moment().unix(),
      });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsers = async () => {
    try {
      setUsersLoading(true);
      const { data } = await axios.get(`/user/v2`);
      setUsers(
        data.data
          .filter((user) => user.is_active)
          .map((user) => {
            const { id, email } = user;
            return {
              value: id,
              label: email,
            };
          }),
      );
    } catch (e) {
      console.log(e);
    } finally {
      setUsersLoading(false);
    }
  };

  return (
    <>
      <Space h='md' />

      <Form values={form} setValues={setForm} fetchSpoc={fetchSpoc} loading={loading} />
      <Container>
        {Object.keys(spocs).length > 0 && (
          <SpocTable
            key={`${spocs.timestamp}`}
            data={spocs}
            users={users}
            loading={usersLoading}
            setData={setSpocs}
          />
        )}
      </Container>
    </>
  );
};

export default AdminSpocs;
